import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTaskWithTaskType = (
    backend: string,
    token: string,
    id: string,
) => {

    return fetch(
        `${getApiUrl(backend)}task_with_task_type/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTaskWithTaskType;
